import { Box, Text } from '@factorialco/deprecated-design-system'

import { CentToFormattedAmount } from 'modules/finance/components/FinancialWorkspace/components/chart/helpers'

import { PARSED_ITEMS } from '../helpers'

interface CurrentProp {
  index: number
  label: string
  showTotal: boolean
  items: PARSED_ITEMS
  showDivider: boolean
  showLaborCost: boolean
  hasComparisonDate: boolean
  showAgreementData: boolean
  showEmployeeExpenses: boolean
  toAmount: (value: number) => CentToFormattedAmount
}

const Current = ({
  items,
  label,
  index,
  toAmount,
  showTotal,
  showDivider,
  showLaborCost,
  hasComparisonDate,
  showAgreementData,
  showEmployeeExpenses,
}: CurrentProp) => {
  const { LABOR_COST, AGREEMENT_DATA, TOTAL_EXPENSES, EMPLOYEE_EXPENSES } = items

  return (
    <Box flexDirection="column" gap="s8" alignItems="flexEnd">
      <Box gap="s8" minHeight="s24" paddingLeft="s24" flexDirection="row" alignItems="center">
        <Text.Normal size="300" weight="bold" color="grey1000">
          {hasComparisonDate ? label : <>&nbsp;</>}
        </Text.Normal>
      </Box>
      {showAgreementData && (
        <Box flexDirection="row" gap="s8" alignItems="center" paddingLeft="s24" minHeight="s24">
          <Text.Normal size="200" color="grey1000">
            {AGREEMENT_DATA?.[index]?.y ? toAmount(Number(AGREEMENT_DATA?.[index]?.y)).amount : '-'}
          </Text.Normal>
        </Box>
      )}
      {showDivider && <Box background="grey200" width="full" height="s2" />}
      {showEmployeeExpenses && (
        <Box flexDirection="row" gap="s8" alignItems="center" paddingLeft="s24" minHeight="s24">
          <Text.Normal size="200" color="grey1000">
            {EMPLOYEE_EXPENSES?.[index]?.y
              ? toAmount(Number(EMPLOYEE_EXPENSES?.[index]?.y)).amount
              : '-'}
          </Text.Normal>
        </Box>
      )}
      {showLaborCost && (
        <Box flexDirection="row" gap="s8" alignItems="center" paddingLeft="s24" minHeight="s24">
          <Text.Normal size="200" color="grey1000">
            {LABOR_COST?.[index]?.y ? toAmount(Number(LABOR_COST?.[index]?.y)).amount : '-'}
          </Text.Normal>
        </Box>
      )}
      {showTotal && (
        <Box flexDirection="row" gap="s8" alignItems="center" paddingLeft="s24" minHeight="s24">
          <Text.Normal weight="medium" size="200" color="grey1000">
            {TOTAL_EXPENSES?.[index]?.y ? toAmount(Number(TOTAL_EXPENSES?.[index]?.y)).amount : '-'}
          </Text.Normal>
        </Box>
      )}
    </Box>
  )
}

export { Current }
